import React, { useState } from "react";

function AccordionItem(props) {
    return <>
        <h2
            className={props.isActive? 'active' : 'hidden'}
            id={props.id}
            onClick={props.onHeaderClick}
        >
            {props.title}
        </h2>
        <section
            className={'accordionSection ' + (props.isActive? 'active' : 'hidden')}
            id={'sec_' + props.id}
        >
            {props.content}
        </section>
    </>;
}

function PageAccordion({ pages }) {
    const firstPageKey = pages[0].key;
    const [activeKey, setActiveKey] = useState(firstPageKey);
    var activeSection;
    setTimeout(() => {
        activeSection = document.getElementById('sec_' + activeKey);
    }, 100);
    return pages.map(page => {
        return (<AccordionItem
            key={page.key}
            id={page.key}
            isActive={page.key === activeKey}
            title={page.title}
            content={page.content}
            onHeaderClick={() => {
                activeSection.style.maxHeight = '0';
                setActiveKey(page.key);
                activeSection = document.getElementById('sec_' + page.key);
                activeSection.style.maxHeight = activeSection.scrollHeight + 'px';
                setTimeout(() => {
                    document.getElementById(page.key).scrollIntoView({
                        behavior: 'smooth'
                    });
                }, 1000);
            }} />);
    });
    // return <>
    //     pages.map(({ title, content }) => <>
    //         <h1>{title}</h1>
    //         {content}
    //     </>);
    // </>;
}

export default PageAccordion;